import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

// get api
export const fetchPrivilegeTypes = () => {
  return apiClient(ENDPOINTS.PRIVILEGE_TYPES, { method: "GET" });
};

// update api
export const updatePrivilege = (id, data) => {
  return apiClient(`${ENDPOINTS.PRIVILEGE_TYPES}/${id}`, {
    method: "PUT",
    body: data,
  });
};

// POST - Create Privilege
export const createPrivilege = (privilegeData) => {
  return apiClient(
    ENDPOINTS.PRIVILEGE_TYPES, // e.g. "/api/Privilege/privilege-types"
    { method: "POST", body: privilegeData },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

// Delete privilege service
export const deletePrivilege = (privilegeId) => {
  return apiClient(
    `${ENDPOINTS.PRIVILEGE_TYPES}/${privilegeId}`,
    { method: "DELETE" }
  );
};

export const fetchAllUsers = () => {
  return apiClient(ENDPOINTS.GET_ALL_USERS, {
    method: "GET",
  });
};


export const fetchUserPrivileges = (userId) => {
  return apiClient(ENDPOINTS.USER_PERMISSIONS(userId), {
    method: "GET",
  });
};

export const assignUserPrivilege = (data) => {
  return apiClient(ENDPOINTS.ASSIGN_USER_PRIVILEGE, {
    method: "POST",
    data,
  });
};

export const assignRolePrivilege = (data) => {
  return apiClient(ENDPOINTS.ASSIGN_ROLE_PRIVILEGE, {
    method: "POST",
    body: data,
  });
};